import axios from 'axios';
import qs from 'qs';
import {Message} from 'element-ui';
import config from '../config'
import router from '../router/index'
import store from '../store/index'

axios.defaults.baseURL = config.baseURL;

const tip = msg => {
    Message({
        message: msg,
        duration: 5000,
        type: 'error'
    });
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    /*post("/authentication/form", {username: 'admin', password: '123456'}).then(passport => {
        store.dispatch("setPassport", passport);
        store.dispatch("handleAuth", passport).then((res) => {
            window.location.reload();
        });
    })*/
    router.replace({
        path: '/login',
        query: {
            redirect: router.currentRoute.fullPath
        }
    });
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, message) => {
    // 状态码判断
    switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
            toLogin();
            break;
        case 403:
            tip('您没有访问权限');
            break;
        // 403 token过期
        // 清除token并跳转登录页
        case 405:
            //tip('登录过期，请重新登录');
            toLogin();
            break;
        // 404请求不存在
        case 404:
            tip('请求的资源不存在');
            break;
        default:
            tip(message);
    }
}

// 创建axios实例
var instance = axios.create({
    timeout: 1000 * 60,
    crossDomain: true,
    withCredentials: true
});
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        const token = localStorage.getItem("token");
        token && (config.headers.Authorization = token);
        return config;
    },
    error => Promise.error(error))

// 响应拦截器
instance.interceptors.response.use(
    res => {
        const env = process.env.NODE_ENV
        // 控制台输出响应数据
        if (env === 'development' || env === 'testing') {
            //console.log(res.data)
        }
        if (res.status === 200 && res.config.responseType === 'blob') { // 文件类型特殊处理
            console.log(res)
            console.log(res.headers['content-disposition']);
            console.log(res.headers['content-type']);
            console.log(res.headers['content-type'].indexOf('application/pdf') != -1);

            return res
            /*if (res.headers['content-disposition'] || (res.headers['content-type'] && res.headers['content-type'].indexOf('application/pdf') != -1)) {
                console.log(res)
                return res.data
            }*/
        } else if (res.status === 200) {
            if (res.data && Object.keys(res.data).length > 0) {
                const {code, data, msg, results, totalCount} = res.data
                if (code == 200) {
                    if (data) {
                        return Promise.resolve(data);
                    } else if (msg) {
                        return Promise.resolve({msg: msg});
                    } else if (results || totalCount) {
                        return Promise.resolve({results: results, totalCount: totalCount});
                    } else {
                        return Promise.resolve('');
                    }
                } else {
                    return Promise.reject(res.data);
                }
            }
        } else {
            return Promise.reject({code: res.status, msg: res.data.message})
        }
    },
    // 请求失败
    error => {
        const {response} = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围
            errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        } else {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
            // store.commit('changeNetwork', false);
        }
    }
);


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params: params
        })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                errorHandle(err.code, err.msg);
                reject(err);
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        instance.post(url, qs.stringify(params))
            .then(response => {
                resolve(response);
            }, err => {
                errorHandle(err.code, err.msg);
                reject(err);
            })
    })
}

/**F
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function upload(url, data) {
    return new Promise((resolve, reject) => {
        instance({
            url: url,
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            resolve(res);
        }, err => {
            errorHandle(err.code, err.msg);
            reject(err);
        })
    });
}

export const postReqestBody = (url, params) => {
    return new Promise((resolve, reject) => {
        instance({
            method: 'post',
            url: url,
            data: params,
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => {
            resolve(res);
        }, err => {
            errorHandle(err.code, err.msg);
            reject(err);
        });
    })
}

export const download = (url, params) => {
    return new Promise((resolve, reject) => {
        instance({
            method: 'post',
            url: url,
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
            responseType: 'blob'
        }).then(res => {
            resolve(res);
        }, err => {
            errorHandle(err.code, err.msg);
            reject(err);
        });
    })
}
